import { useEffect, useState } from "react";
import { FiRefreshCw } from "react-icons/fi";
import { Button } from "./ui";

// Muestra un aviso cuando el service worker detecta una versión nueva (ver index.js).
export default function UpdatePrompt() {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const onUpdate = (e) => setRegistration(e.detail);
    window.addEventListener("sw-update", onUpdate);
    return () => window.removeEventListener("sw-update", onUpdate);
  }, []);

  if (!registration?.waiting) return null;

  const update = () => {
    navigator.serviceWorker.addEventListener("controllerchange", () => window.location.reload(), { once: true });
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
  };

  return (
    <div className="fixed inset-x-4 bottom-20 z-50 mx-auto flex max-w-md animate-fade-in items-center gap-3 rounded-2xl bg-slate-900 p-4 text-white shadow-2xl md:bottom-6 print:hidden">
      <FiRefreshCw className="h-5 w-5 shrink-0 text-brand-300" />
      <p className="flex-1 text-sm">Hay una nueva versión de OdontoSend.</p>
      <Button size="sm" variant="white" onClick={update}>
        Actualizar
      </Button>
    </div>
  );
}
